import * as React from 'react';
import { Box, Collapse, Typography } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import pxToRem from 'assets/theme/function/px-to-rem';
import colors from 'assets/theme/base/colors';
import { useMemo } from 'react';
import { menuItems } from 'routes/routes';
import { useLocation } from 'react-router-dom';
import { MenuItemParams } from 'types/routes/route-params';
import rgba from 'assets/theme/function/rgba';
import borders from 'assets/theme/base/borders';

interface Props {
    children?: React.ReactNode;
    defaultOpen?: boolean;
    name?: string;
    display?: boolean;
}

const findRouteByPath = (
    routes: MenuItemParams[],
    pathname: string,
): MenuItemParams | undefined => {
    for (const route of routes) {
        if (route.path === pathname) {
            return route;
        }
        if (route.subRoutes) {
            const found = findRouteByPath(route.subRoutes, pathname);
            if (found) return found;
        }
    }
    return undefined;
};

const Filters: React.FC<Props> = ({
    children,
    defaultOpen = true,
    display = false,
    name,
}) => {
    const [open, setOpen] = React.useState(defaultOpen);
    const { pathname } = useLocation();

    const routeInfo = useMemo<MenuItemParams | undefined>(() => {
        return findRouteByPath(menuItems, pathname);
    }, [pathname]);

    return (
        <>
            <Box
                pl={pxToRem(10)}
                pt={pxToRem(5)}
                display="flex"
                alignItems="center"
            >
                <Typography variant="h4">{routeInfo?.name ?? name}</Typography>

                {!display && (
                    <Box
                        sx={{ cursor: 'pointer' }}
                        pl={pxToRem(10)}
                        pt={pxToRem(5)}
                        onClick={() => setOpen((prev) => !prev)}
                    >
                        {open ? (
                            <FilterListIcon
                                sx={{ color: colors.primary.main }}
                            />
                        ) : (
                            <FilterListOffIcon
                                sx={{ color: colors.common.white }}
                            />
                        )}
                    </Box>
                )}
            </Box>
            <Collapse timeout={300} in={open}>
                <Box
                    border={`1px solid ${rgba(colors.info.main, 0.5)}`}
                    borderRadius={borders.borderRadius.md}
                    p={pxToRem(8)}
                    pb={pxToRem(15)}
                    mb={open ? pxToRem(10) : pxToRem(0)}
                >
                    {children}
                </Box>
            </Collapse>
        </>
    );
};

export default Filters;
